import React, { useState } from "react";
import { FontAwesomeIcon } from '@fortawesome/react-fontawesome'
import { faUser } from '@fortawesome/free-solid-svg-icons'
import { motion } from "framer-motion"
import { Link } from "react-router-dom";
import { useStateContext } from "../../context/ind";
import { useAuth0 } from "@auth0/auth0-react";
function Sidebar(){
    const [show,setshow]=useState(0);
    const { loginWithRedirect, isAuthenticated, user,logout } = useAuth0();
    const { connect, address } = useStateContext();
    return (

        <div class="h-[100vh] w-[20vw] px-3 py-4 overflow-y-auto bg-gray-50 dark:bg-gray-800  ">
         <h1 class='  font-bold mb-[30vh]'  style={{fontSize:'3vw'}}>MedVault</h1>
      <ul class="space-y-2 font-medium h-[40vh] flex flex-col justify-between items-center ">
         <li>
            <Link to='' class="flex items-center p-2 text-gray-900 rounded-lg dark:text-white hover:bg-gray-100 dark:hover:bg-gray-700">
               <svg aria-hidden="true" class="w-6 h-6 text-gray-500 transition duration-75 dark:text-gray-400 group-hover:text-gray-900 dark:group-hover:text-white" fill="currentColor" viewBox="0 0 20 20" xmlns="http://www.w3.org/2000/svg"><path d="M2 10a8 8 0 018-8v8h8a8 8 0 11-16 0z"></path><path d="M12 2.252A8.014 8.014 0 0117.748 8H12V2.252z"></path></svg>
               <span class="ml-3 " style={{fontSize:'1.7vw'}} >   Dashboard</span>
            </Link>
         </li>
         <Link to='dashboard' class="flex items-center p-2 text-gray-900 rounded-lg dark:text-white hover:bg-gray-100 dark:hover:bg-gray-700">
               <svg aria-hidden="true" class="w-6 h-6 text-gray-500 transition duration-75 dark:text-gray-400 group-hover:text-gray-900 dark:group-hover:text-white" fill="currentColor" viewBox="0 0 20 20" xmlns="http://www.w3.org/2000/svg"><path d="M2 10a8 8 0 018-8v8h8a8 8 0 11-16 0z"></path><path d="M12 2.252A8.014 8.014 0 0117.748 8H12V2.252z"></path></svg>
               <span class="ml-3 "  style={{fontSize:'1.7vw'}}>Appointments</span>
            </Link>
            <Link to='addReport' class="flex items-center p-2 text-gray-900 rounded-lg dark:text-white hover:bg-gray-100 dark:hover:bg-gray-700">
               <svg aria-hidden="true" class="w-6 h-6 text-gray-500 transition duration-75 dark:text-gray-400 group-hover:text-gray-900 dark:group-hover:text-white" fill="currentColor" viewBox="0 0 20 20" xmlns="http://www.w3.org/2000/svg"><path d="M2 10a8 8 0 018-8v8h8a8 8 0 11-16 0z"></path><path d="M12 2.252A8.014 8.014 0 0117.748 8H12V2.252z"></path></svg>
               <span class="ml-3  " style={{fontSize:'1.7vw'}} >Add Report</span>
            </Link>
         <li>
         <Link onClick={logout} class="flex items-center p-2 text-gray-900 rounded-lg dark:text-white hover:bg-gray-100 dark:hover:bg-gray-700">
               <svg aria-hidden="true" class="w-6 h-6 text-gray-500 transition duration-75 dark:text-gray-400 group-hover:text-gray-900 dark:group-hover:text-white" fill="currentColor" viewBox="0 0 20 20" xmlns="http://www.w3.org/2000/svg"><path d="M2 10a8 8 0 018-8v8h8a8 8 0 11-16 0z"></path><path d="M12 2.252A8.014 8.014 0 0117.748 8H12V2.252z"></path></svg>
               <span class="ml-3 "  style={{fontSize:'1.7vw'}} >Logout</span>
            </Link>
         </li>
        
         
      </ul>
   </div>
    );

}
export default Sidebar;